<mat-toolbar class="bg-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Solicitar autorización</span>
    </mat-toolbar-row>
</mat-toolbar>

<div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>

    <lib-en-autorizacion-diligencia-form
        [diligencia]="diligencia"
        [configAutorizador]="configAutorizador"
        [origen]="origen"
        [organizacionOrigen]="this.organizacionOrigen"
        [generarFormato]="this.generarFormato">
    </lib-en-autorizacion-diligencia-form>

    <div fxLayout="row" fxLayoutAlign="end end">
        <button mat-button (click)="dialogRef.close()">Cancelar</button>
        <button mat-raised-button type="button" color="accent" (click)="save()" [disabled]="!formValid">
            Enviar
        </button>
    </div>
</div>
